import bishan_tongban from './intro.json'

export const introduce_bishan_tongban = bishan_tongban
